
const FeedbackHero = () => {
  return (
    <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-[#F5E6D3] to-[#E8D4B8]">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1B3A52] mb-5">
          Reader Testimonials
        </h1>
        <p className="text-base text-gray-700 leading-relaxed max-w-2xl mx-auto">
          Discover how Pastor Don R. Vining's books have transformed lives and deepened faith journeys.
        </p>
      </div>
    </section>
  );
};

export default FeedbackHero;
